
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqe8tCtsyT6LVEGYacE1BfUaBAi9xM1O91T3Q6w_O2qEMMeta } from "/vercel/path0/apps/bitbelicash/pages/faq.vue?macro=true";
import { default as indexZwQ0qdtlIc1ImvoMX_45OTw_45lZZoDxsep0IKPBabm8nL8Meta } from "/vercel/path0/apps/bitbelicash/pages/index.vue?macro=true";
import { default as loginMN6itfFQv8pEtWsPy0hY_qHsa9zPmj3LJZC7vhEmF8MMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/login.vue?macro=true";
import { default as logoutsr38LBI7aWyO_45cmy96Y72WC_45WYvjRsL_XBVrDQDnUwoMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/logout.vue?macro=true";
import { default as faqeXoybBhk7DWDpI8txUr06PsZrdIDGrNywY1f8ArsOf4Meta } from "/vercel/path0/apps/bitbelicash/pages/profile/faq.vue?macro=true";
import { default as kyb_45vRyiSl_45KMcSG_45IPdLRN1KkiDKuemsAHBOqDIrsicxUMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/kyb.vue?macro=true";
import { default as indexKZBzrG4ojB0XH78RdIfoFdmm7LC_459w7XVjPU_G4uRiEMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/index.vue?macro=true";
import { default as chargesD_45P__45HOpxnApj7M2O3J_AcWJTaYjQCn8LkueI1ZQx_45kMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/charges.vue?macro=true";
import { default as _91id_93K4XxfwP6fTaFvploSmC0kxVRPk7_45gjePM23E36WnIK8Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/[id].vue?macro=true";
import { default as overlimitydT8dSfbty2kFXpAWdu9wTqEgNGXSue0m115dg6Oyh0Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/overlimit.vue?macro=true";
import { default as indexB8Jvoj6Imu5nOPKfHtYjrjjaSpkDlNtfjMRbBL0q_2oMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/index.vue?macro=true";
import { default as statisticsWBJRPlr5N0Zhep7_45zMZ5IcWTYLG8uWxPsKWXAwAQ_fYMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/statistics.vue?macro=true";
import { default as _91id_93C6qtoWHZM4QH4j294jYCnQmAEKDazp0NKUqkmPVaklQMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/[id].vue?macro=true";
import { default as _91id_93dUIGLBFzrZ2lteuKTqXHO4fVi3w_45CN2ymZ8oGIO9wQMMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/[id].vue?macro=true";
import { default as indexZx7QkcKYTK7wiZtSXjzVUT2D5PazBHY4n3VLL4OqYooMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/index.vue?macro=true";
import { default as indexkknAEM0qgrFPfuWGaab0RGZmc7CrpzTUJByrtOhIfOsMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/index.vue?macro=true";
import { default as transactionsWMP1EBawRQvIn7cydd3zQyzdGpKYTfQuhs8Z4JshrScMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/transactions.vue?macro=true";
import { default as bank_45accountsV_t00L6RKzXmaC5MeMZ2YJ4YL4eiEoN4GD33AlMa31EMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank-accounts.vue?macro=true";
import { default as _91id_93J5w0p5mG1Sqg0ouMn_45EeFkKw_oSgkgmdPjYvkcqWemMMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/[id].vue?macro=true";
import { default as indexz_45NHhQb6aLecfEj1BFpwndtsn6WqsPwGKeVS7uYpSRkMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/index.vue?macro=true";
import { default as _91id_93g4SANzRBe5k0oLiBFweojezt3ZjyGQEJRn4cbNSw8dAMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/branches/[id].vue?macro=true";
import { default as adminxoHPY1PNPC2SrOstzov4KuUO0rHm3forLL7uUhzXT3wMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin.vue?macro=true";
import { default as indexqQ3On7t0j_K41jrND2jHwLd_453iiqSbTwQY6FFTb4hykMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/index.vue?macro=true";
import { default as rewardsneyU4fN2yOX21aAi4v9nRzw9hd4EAW_hicQKDphu6tYMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/rewards.vue?macro=true";
import { default as withdrawalsvzhRF5_TrpObOR7FGLvQl4rII5LVgopbZweMFgasSDAMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/withdrawals.vue?macro=true";
import { default as bonusOKcKNC56_45D_g6FmJ2K2lgPaQG1kKiCrmfsHwHy5evcEMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus.vue?macro=true";
import { default as index04QJKf6T_45pNhb1dk3drwGhxyk0ZiTvEkztK9zY2wD4cMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/index.vue?macro=true";
import { default as indexB6QCImTenzqO_456M3kVrVA8t0Nh0i65jsfHV5A_45z_456ywMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/account/index.vue?macro=true";
import { default as verifyud5q51uIAhkYwS7FmgSTU7vQOod62tg5F15KSOMbyzsMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/account/verify.vue?macro=true";
import { default as bank_45accountsAZl2THTmevaOBIf3VapB4S2qppht59W6UiJi7fNl2n4Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/account/bank-accounts.vue?macro=true";
import { default as change_45password5NMEmUWSTsCLIhcxhfcNu854rO2ejj8QJ_45ZD293WdwgMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/account/change-password.vue?macro=true";
import { default as accountrHtEEXlfKY_453mpPN_6lVhzbA00UdsmKXu6yVTxYhqboMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/account.vue?macro=true";
import { default as historyjeP2VlUYv3D0SQPnFETNg0adbwHc48_45ZB9KAB5yjBioMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/history.vue?macro=true";
import { default as index0YRiM5vbjL2RFcpD4BsbdED2sVRHLoMV9HmJRFopEtYMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/cashdesk/index.vue?macro=true";
import { default as closuresdsNfFdRSBhfEH9odrbUoR_45CO7N1nUnRsrNJoPG2h7mcMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/cashdesk/closures.vue?macro=true";
import { default as cashdeskWd1VmVUliCFhixKoNiLOpB5lQpcJ3uBa_45erPtdI_45MUUMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/cashdesk.vue?macro=true";
import { default as exchangeYZIhb2jLGCSwnTPdD9u5mqyLWdJ_SSKyFlNY9_45CY5kIMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange.vue?macro=true";
import { default as overviewaTASzYAZWU6uurcph_45sp42ELmtvyXvFFZHWjlp_45OsnkMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/overview.vue?macro=true";
import { default as indexxNkk8nVqaRN6O2NzagEE9PohaU9_45_rVU025NkigcZfoMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/index.vue?macro=true";
import { default as usersYtGW9j7onaeeAihssNsVEHs_45qClKmN7XYbTlBy_45d1NYMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/users.vue?macro=true";
import { default as ordersT85M8QpTXvc7g7_tdSVnxIVCy_3DnDme5WA1Oh_451Z04Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/orders.vue?macro=true";
import { default as chargesekvxRCXRytUvpDQWivPata_45o53MwXUiNh8ii0eT87OoMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/charges.vue?macro=true";
import { default as transactionsH8URdmr5pbJuv3tFqs27mfBsIRgyXOUMLqxzKqwgEUgMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/transactions.vue?macro=true";
import { default as inspectorW9wug0sHb1nKcCmEpQl_45McfcnozAYU_vl5LuNjtIks0Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector.vue?macro=true";
import { default as _91id_93gjy2opx9IQQo339UulrW8TayMOxLvvTysErXi1R2f78Meta } from "/vercel/path0/apps/bitbelicash/pages/profile/orders/[id].vue?macro=true";
import { default as verify_45resultzbxCjqVIiNfJ1h8vWqRjHKxjHsUfL6ucPlVIQl48M9MMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/verify-result.vue?macro=true";
import { default as index_456f97jXLmrQqZ_nG3hYi2g4Ds6rHKQu135XPM_45WR3IkMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/index.vue?macro=true";
import { default as clientsrWqoTgnZs0zxxnDIelDznYxkUEZLNDRM1gas6nh4iDAMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/clients.vue?macro=true";
import { default as settingsI8FgjUzMZki8gH7Zv3OJ0CHGDXTPxugbAoWt9GfL7ksMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/settings.vue?macro=true";
import { default as employeeshVLgtVnW6diaPfWqNt5oPXuFbZlCtTGBmQ7mIAtMzpQMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/employees.vue?macro=true";
import { default as exchangesaUgQX8nSRseIvuaPf8rVFrHoZsaLRnY1AmJETv1yE6QMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/exchanges.vue?macro=true";
import { default as _91id_93yMjHWL_Wa0mkO_BdDulNYue8YhlUpIT_tNe0hrvdWloMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/branches/[id].vue?macro=true";
import { default as indexTQavwqth3iejaKPsY81KCFlQme1dLwppd6RFKBCaMxkMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/branches/index.vue?macro=true";
import { default as exchange_45officeNv1vch0Gaj0efX6dn_45wTP9Mc5Jh2NIKAz3JP8GRSiIMMeta } from "/vercel/path0/apps/bitbelicash/pages/profile/exchange-office.vue?macro=true";
import { default as profileo_k2RMPPMdX_AgxXCeROglqbszRmvIGYk_1yMy3_45YwQMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile.vue?macro=true";
import { default as _91uuid_93h7Fs6pd_JC7pOqisUyQHUb6Vj1564YIWHfAOyOOTnaYMeta } from "/vercel/path0/apps/bitbelicash/pages/order/[uuid].vue?macro=true";
import { default as verify_45resultlNkKhplaycqayZyRn7OEWRU94bDkGWqaxMgCKBzaNxcMeta } from "/vercel/path0/apps/bitbelicash/pages/verify-result.vue?macro=true";
import { default as email_45verifiedwieJmRnUCdruWrnrEoR8AmAqTrzcqPGZsfDgNsROWp0Meta } from "/vercel/path0/layers/modules/fubex-auth/pages/email-verified.vue?macro=true";
import { default as signup_45success_45wQ_ysq4nYMMCotjupnHU8k6gSDlucyCJQnJdBdod1EMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/signup-success.vue?macro=true";
import { default as _91userId_93pSRVmUJMrepxiyVJLHF2_45lW6SkACnfTownOum_45WzXC4Meta } from "/vercel/path0/layers/modules/fubex-auth/pages/invite/[userId].vue?macro=true";
import { default as kurzovni_45listek1WCjHDb9c9XFnF0Xd_t6jnUOoboyvP5dbRdrRcgjmhsMeta } from "/vercel/path0/apps/bitbelicash/pages/kurzovni-listek.vue?macro=true";
import { default as update_45passwordPB2r4tb93DtNSimYEbJ1mL7mlVTakVPo8UvZb9uIItgMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/update-password.vue?macro=true";
import { default as component_45stubXCKypl2yOKwoj667BeiN62hVejFxTGDYT_bPNw0FFMQMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@24.1.0_@upstash+redis@1.35.0_@vue+compile_7fce59830cf89b2ec31e1e9286565a79/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubXCKypl2yOKwoj667BeiN62hVejFxTGDYT_bPNw0FFMQ } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@24.1.0_@upstash+redis@1.35.0_@vue+compile_7fce59830cf89b2ec31e1e9286565a79/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/logout.vue")
  },
  {
    name: "profile-parent",
    path: "/profile",
    meta: { ...(profileo_k2RMPPMdX_AgxXCeROglqbszRmvIGYk_1yMy3_45YwQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile.vue"),
    children: [
  {
    name: "profile-faq",
    path: "faq",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/faq.vue")
  },
  {
    name: adminxoHPY1PNPC2SrOstzov4KuUO0rHm3forLL7uUhzXT3wMeta?.name,
    path: "admin",
    meta: {"middleware":"admin"},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin.vue"),
    children: [
  {
    name: "profile-admin-kyb",
    path: "kyb",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/kyb.vue")
  },
  {
    name: "profile-admin",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/index.vue")
  },
  {
    name: "profile-admin-charges",
    path: "charges",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/charges.vue")
  },
  {
    name: "profile-admin-bank-id",
    path: "bank/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/[id].vue")
  },
  {
    name: "profile-admin-overlimit",
    path: "overlimit",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/overlimit.vue")
  },
  {
    name: "profile-admin-bank",
    path: "bank",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/index.vue")
  },
  {
    name: "profile-admin-statistics",
    path: "statistics",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/statistics.vue")
  },
  {
    name: "profile-admin-users-id",
    path: "users/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/[id].vue")
  },
  {
    name: "profile-admin-orders-id",
    path: "orders/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/[id].vue")
  },
  {
    name: "profile-admin-users",
    path: "users",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/index.vue")
  },
  {
    name: "profile-admin-orders",
    path: "orders",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/index.vue")
  },
  {
    name: "profile-admin-transactions",
    path: "transactions",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/transactions.vue")
  },
  {
    name: "profile-admin-bank-accounts",
    path: "bank-accounts",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank-accounts.vue")
  },
  {
    name: "profile-admin-exchange-office-id",
    path: "exchange-office/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/[id].vue")
  },
  {
    name: "profile-admin-exchange-office",
    path: "exchange-office",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/index.vue")
  },
  {
    name: "profile-admin-exchange-office-branches-id",
    path: "exchange-office/branches/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/branches/[id].vue")
  }
]
  },
  {
    name: "bonus",
    path: "bonus",
    meta: bonusOKcKNC56_45D_g6FmJ2K2lgPaQG1kKiCrmfsHwHy5evcEMeta || {},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus.vue"),
    children: [
  {
    name: "profile-bonus",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/index.vue")
  },
  {
    name: "profile-bonus-rewards",
    path: "rewards",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/rewards.vue")
  },
  {
    name: "profile-bonus-withdrawals",
    path: "withdrawals",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/withdrawals.vue")
  }
]
  },
  {
    name: "profile",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/index.vue")
  },
  {
    name: "account",
    path: "account",
    meta: accountrHtEEXlfKY_453mpPN_6lVhzbA00UdsmKXu6yVTxYhqboMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account",
    path: "",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/account/index.vue")
  },
  {
    name: "profile-account-verify",
    path: "verify",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/verify.vue")
  },
  {
    name: "profile-account-bank-accounts",
    path: "bank-accounts",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/bank-accounts.vue")
  },
  {
    name: "profile-account-change-password",
    path: "change-password",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/account/change-password.vue")
  }
]
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/history.vue")
  },
  {
    name: "cashdesk",
    path: "cashdesk",
    meta: cashdeskWd1VmVUliCFhixKoNiLOpB5lQpcJ3uBa_45erPtdI_45MUUMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/cashdesk.vue"),
    children: [
  {
    name: "profile-cashdesk",
    path: "",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/cashdesk/index.vue")
  },
  {
    name: "profile-cashdesk-closures",
    path: "closures",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/cashdesk/closures.vue")
  }
]
  },
  {
    name: "profile-exchange",
    path: "exchange",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange.vue")
  },
  {
    name: "profile-overview",
    path: "overview",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/overview.vue")
  },
  {
    name: inspectorW9wug0sHb1nKcCmEpQl_45McfcnozAYU_vl5LuNjtIks0Meta?.name,
    path: "inspector",
    meta: {"middleware":"inspector"},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector.vue"),
    children: [
  {
    name: "profile-inspector",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/index.vue")
  },
  {
    name: "profile-inspector-users",
    path: "users",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/users.vue")
  },
  {
    name: "profile-inspector-orders",
    path: "orders",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/orders.vue")
  },
  {
    name: "profile-inspector-charges",
    path: "charges",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/charges.vue")
  },
  {
    name: "profile-inspector-transactions",
    path: "transactions",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/transactions.vue")
  }
]
  },
  {
    name: "profile-orders-id",
    path: "orders/:id()",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/orders/[id].vue")
  },
  {
    name: "profile-verify-result",
    path: "verify-result",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/verify-result.vue")
  },
  {
    name: "exchangeOffice",
    path: "exchange-office",
    meta: exchange_45officeNv1vch0Gaj0efX6dn_45wTP9Mc5Jh2NIKAz3JP8GRSiIMMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office.vue"),
    children: [
  {
    name: "profile-exchange-office",
    path: "",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/index.vue")
  },
  {
    name: "profile-exchange-office-clients",
    path: "clients",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/clients.vue")
  },
  {
    name: "profile-exchange-office-settings",
    path: "settings",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/settings.vue")
  },
  {
    name: "profile-exchange-office-employees",
    path: "employees",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/employees.vue")
  },
  {
    name: "profile-exchange-office-exchanges",
    path: "exchanges",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/exchanges.vue")
  },
  {
    name: "profile-exchange-office-branches-id",
    path: "branches/:id()",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/branches/[id].vue")
  },
  {
    name: "profile-exchange-office-branches",
    path: "branches",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/branches/index.vue")
  }
]
  }
]
  },
  {
    name: "order-uuid",
    path: "/order/:uuid()",
    meta: _91uuid_93h7Fs6pd_JC7pOqisUyQHUb6Vj1564YIWHfAOyOOTnaYMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/order/[uuid].vue")
  },
  {
    name: "verify-result",
    path: "/verify-result",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/verify-result.vue")
  },
  {
    name: "email-verified",
    path: "/email-verified",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/email-verified.vue")
  },
  {
    name: "signup-success",
    path: "/signup-success",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/signup-success.vue")
  },
  {
    name: "invite-userId",
    path: "/invite/:userId()",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/invite/[userId].vue")
  },
  {
    name: "kurzovni-listek",
    path: "/kurzovni-listek",
    meta: { ...(kurzovni_45listek1WCjHDb9c9XFnF0Xd_t6jnUOoboyvP5dbRdrRcgjmhsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/apps/bitbelicash/pages/kurzovni-listek.vue")
  },
  {
    name: "update-password",
    path: "/update-password",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/update-password.vue")
  },
  {
    name: component_45stubXCKypl2yOKwoj667BeiN62hVejFxTGDYT_bPNw0FFMQMeta?.name,
    path: "/profile/",
    component: component_45stubXCKypl2yOKwoj667BeiN62hVejFxTGDYT_bPNw0FFMQ
  },
  {
    name: "localized-faq",
    path: "/:locale(en)/faq",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/faq.vue")
  },
  {
    name: "localized-index",
    path: "/:locale(en)",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/index.vue")
  },
  {
    name: "localized-login",
    path: "/:locale(en)/login",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/login.vue")
  },
  {
    name: "localized-logout",
    path: "/:locale(en)/logout",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/logout.vue")
  },
  {
    name: "localized-profile-parent",
    path: "/:locale(en)/profile",
    meta: { ...(profileo_k2RMPPMdX_AgxXCeROglqbszRmvIGYk_1yMy3_45YwQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile.vue"),
    children: [
  {
    name: "localized-profile-faq",
    path: "faq",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/faq.vue")
  },
  {
    name: "localized-undefined",
    path: "admin",
    meta: {"middleware":"admin"},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin.vue"),
    children: [
  {
    name: "localized-profile-admin-kyb",
    path: "kyb",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/kyb.vue")
  },
  {
    name: "localized-profile-admin",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/index.vue")
  },
  {
    name: "localized-profile-admin-charges",
    path: "charges",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/charges.vue")
  },
  {
    name: "localized-profile-admin-bank-id",
    path: "bank/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/[id].vue")
  },
  {
    name: "localized-profile-admin-overlimit",
    path: "overlimit",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/overlimit.vue")
  },
  {
    name: "localized-profile-admin-bank",
    path: "bank",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/index.vue")
  },
  {
    name: "localized-profile-admin-statistics",
    path: "statistics",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/statistics.vue")
  },
  {
    name: "localized-profile-admin-users-id",
    path: "users/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/[id].vue")
  },
  {
    name: "localized-profile-admin-orders-id",
    path: "orders/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/[id].vue")
  },
  {
    name: "localized-profile-admin-users",
    path: "users",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/index.vue")
  },
  {
    name: "localized-profile-admin-orders",
    path: "orders",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/index.vue")
  },
  {
    name: "localized-profile-admin-transactions",
    path: "transactions",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/transactions.vue")
  },
  {
    name: "localized-profile-admin-bank-accounts",
    path: "bank-accounts",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank-accounts.vue")
  },
  {
    name: "localized-profile-admin-exchange-office-id",
    path: "exchange-office/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/[id].vue")
  },
  {
    name: "localized-profile-admin-exchange-office",
    path: "exchange-office",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/index.vue")
  },
  {
    name: "localized-profile-admin-exchange-office-branches-id",
    path: "exchange-office/branches/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/branches/[id].vue")
  }
]
  },
  {
    name: "localized-bonus",
    path: "bonus",
    meta: bonusOKcKNC56_45D_g6FmJ2K2lgPaQG1kKiCrmfsHwHy5evcEMeta || {},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus.vue"),
    children: [
  {
    name: "localized-profile-bonus",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/index.vue")
  },
  {
    name: "localized-profile-bonus-rewards",
    path: "rewards",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/rewards.vue")
  },
  {
    name: "localized-profile-bonus-withdrawals",
    path: "withdrawals",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/withdrawals.vue")
  }
]
  },
  {
    name: "localized-profile",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/index.vue")
  },
  {
    name: "localized-account",
    path: "account",
    meta: accountrHtEEXlfKY_453mpPN_6lVhzbA00UdsmKXu6yVTxYhqboMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/account.vue"),
    children: [
  {
    name: "localized-profile-account",
    path: "",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/account/index.vue")
  },
  {
    name: "localized-profile-account-verify",
    path: "verify",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/verify.vue")
  },
  {
    name: "localized-profile-account-bank-accounts",
    path: "bank-accounts",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/bank-accounts.vue")
  },
  {
    name: "localized-profile-account-change-password",
    path: "change-password",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/account/change-password.vue")
  }
]
  },
  {
    name: "localized-profile-history",
    path: "history",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/history.vue")
  },
  {
    name: "localized-cashdesk",
    path: "cashdesk",
    meta: cashdeskWd1VmVUliCFhixKoNiLOpB5lQpcJ3uBa_45erPtdI_45MUUMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/cashdesk.vue"),
    children: [
  {
    name: "localized-profile-cashdesk",
    path: "",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/cashdesk/index.vue")
  },
  {
    name: "localized-profile-cashdesk-closures",
    path: "closures",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/cashdesk/closures.vue")
  }
]
  },
  {
    name: "localized-profile-exchange",
    path: "exchange",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange.vue")
  },
  {
    name: "localized-profile-overview",
    path: "overview",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/overview.vue")
  },
  {
    name: "localized-undefined",
    path: "inspector",
    meta: {"middleware":"inspector"},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector.vue"),
    children: [
  {
    name: "localized-profile-inspector",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/index.vue")
  },
  {
    name: "localized-profile-inspector-users",
    path: "users",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/users.vue")
  },
  {
    name: "localized-profile-inspector-orders",
    path: "orders",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/orders.vue")
  },
  {
    name: "localized-profile-inspector-charges",
    path: "charges",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/charges.vue")
  },
  {
    name: "localized-profile-inspector-transactions",
    path: "transactions",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/transactions.vue")
  }
]
  },
  {
    name: "localized-profile-orders-id",
    path: "orders/:id()",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/orders/[id].vue")
  },
  {
    name: "localized-profile-verify-result",
    path: "verify-result",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/verify-result.vue")
  },
  {
    name: "localized-exchangeOffice",
    path: "exchange-office",
    meta: exchange_45officeNv1vch0Gaj0efX6dn_45wTP9Mc5Jh2NIKAz3JP8GRSiIMMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office.vue"),
    children: [
  {
    name: "localized-profile-exchange-office",
    path: "",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/index.vue")
  },
  {
    name: "localized-profile-exchange-office-clients",
    path: "clients",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/clients.vue")
  },
  {
    name: "localized-profile-exchange-office-settings",
    path: "settings",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/settings.vue")
  },
  {
    name: "localized-profile-exchange-office-employees",
    path: "employees",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/employees.vue")
  },
  {
    name: "localized-profile-exchange-office-exchanges",
    path: "exchanges",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/exchanges.vue")
  },
  {
    name: "localized-profile-exchange-office-branches-id",
    path: "branches/:id()",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/branches/[id].vue")
  },
  {
    name: "localized-profile-exchange-office-branches",
    path: "branches",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/profile/exchange-office/branches/index.vue")
  }
]
  }
]
  },
  {
    name: "localized-order-uuid",
    path: "/:locale(en)/order/:uuid()",
    meta: _91uuid_93h7Fs6pd_JC7pOqisUyQHUb6Vj1564YIWHfAOyOOTnaYMeta || {},
    component: () => import("/vercel/path0/apps/bitbelicash/pages/order/[uuid].vue")
  },
  {
    name: "localized-verify-result",
    path: "/:locale(en)/verify-result",
    component: () => import("/vercel/path0/apps/bitbelicash/pages/verify-result.vue")
  },
  {
    name: "localized-email-verified",
    path: "/:locale(en)/email-verified",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/email-verified.vue")
  },
  {
    name: "localized-signup-success",
    path: "/:locale(en)/signup-success",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/signup-success.vue")
  },
  {
    name: "localized-invite-userId",
    path: "/:locale(en)/invite/:userId()",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/invite/[userId].vue")
  },
  {
    name: "localized-kurzovni-listek",
    path: "/:locale(en)/kurzovni-listek",
    meta: { ...(kurzovni_45listek1WCjHDb9c9XFnF0Xd_t6jnUOoboyvP5dbRdrRcgjmhsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/apps/bitbelicash/pages/kurzovni-listek.vue")
  },
  {
    name: "localized-update-password",
    path: "/:locale(en)/update-password",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/update-password.vue")
  },
  {
    name: "localized-profile",
    path: "/:locale(en)/profile",
    component: component_45stubXCKypl2yOKwoj667BeiN62hVejFxTGDYT_bPNw0FFMQ
  }
]